import { createAction, props } from '@ngrx/store';
import { InvoiceHistory, InvoiceHistoryRequestData, InvoiceSummaryAvisResponse, InvoiceSummaryDetailResponse } from '../custom-user-payments.models';

// *****************************************************

export const getUserPayments = createAction(
    '[Custom User Payments] get user payments',
  );

export const getUserPaymentsSuccess = createAction(
    '[Custom User Payments] get user payments success',
    props<{ invoiceOverview: InvoiceHistory }>()
);
  
export const getUserPaymentsFailure = createAction(
    '[Custom User Payments] get user payments failure',
    props<{ error: Error }>()
);

// *****************************************************

export const searchUserPayments = createAction(
    '[Custom User Payments] search user payments',
    props<{ invoiceHistoryRequestData: InvoiceHistoryRequestData }>()
  );

export const searchUserPaymentsSuccess = createAction(
    '[Custom User Payments] search user payments success',
    props<{ invoiceOverview: InvoiceHistory }>()
);
  
export const searchUserPaymentsFailure = createAction(
    '[Custom User Payments] search user payments failure',
    props<{ error: Error }>()
);

// *****************************************************

export const sortUserPayments = createAction(
    '[Custom User Payments Filters] sort user payments',
    props<{ invoiceHistoryRequestData: InvoiceHistoryRequestData }>()
);

export const backToUserPayments = createAction(
    '[Custom User Payments Filters] back to user payments'
);

export const resetBackToUserPayments = createAction(
    '[Custom User Payments Filters] reset back to user payments'
);

// *****************************************************

export const getUserPaymentsDetails = createAction(
    '[Custom User Payments Details] get user payments details',
    props<{
        invoiceNumber: string;
        companyCode: string;
        bookingYear: string;
        bookingTime: string;
      }>()
  );

export const getUserPaymentsDetailsSuccess = createAction(
    '[Custom User Payments Details] get user payments details success',
    props<{ invoiceDetails: InvoiceSummaryDetailResponse }>()
);
  
export const getUserPaymentsDetailsFailure = createAction(
    '[Custom User Payments Details] get user payments details failure',
    props<{ error: Error }>()
);

// *****************************************************

export const getUserPaymentsAvis = createAction(
    '[Custom User Payments Avis] get user payments avis',
    props<{
        avisNumber: string;
        avisDate: string;
      }>()
  );

export const getUserPaymentsAvisSuccess = createAction(
    '[Custom User Payments Avis] get user payments avis success',
    props<{ invoiceAvis: InvoiceSummaryAvisResponse }>()
);
  
export const getUserPaymentsAvisFailure = createAction(
    '[Custom User Payments Details] get user payments avis failure',
    props<{ error: Error }>()
);